// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__PSFAF","right":"styles_right__2afyd"};